import { render, staticRenderFns } from "./tabInvoiceIndex.vue?vue&type=template&id=fa7e521e"
import script from "./tabInvoiceIndex.vue?vue&type=script&lang=js"
export * from "./tabInvoiceIndex.vue?vue&type=script&lang=js"
import style0 from "./tabInvoiceIndex.vue?vue&type=style&index=0&id=fa7e521e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports